import React from "react";

import PropTypes from "prop-types";
import * as AiIcons from "react-icons/ai";
import { Badge, Col, Row, Stack } from "react-bootstrap";
import { FormatDateWTime } from "../../utils/FormatData";
import AdvanceTableFooter from "../../components/AdvanceTableFooter";
import AdvanceTablePagination from "../../components/AdvanceTablePagination";
import AdvanceTable from "../../components/AdvanceTable";
import BtnExportToExcell from "../../utils/BtnExportToExcell";
import AdvanceTableWrapper from "../../components/AdvanceTableWrapper";
const columns = [
  {
    accessor: "vc_partner",
    Header: "Partner",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Col style={{ textAlign: "left", fontSize: "smaller" }}>
            {rowInfo.vc_partner}
          </Col>
        </>
      );
    },
  },
  {
    accessor: "time_id",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "left" }}>
          {FormatDateWTime(rowInfo.time_id)}
        </Col>
      );
    },
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Recibida</div>
      );
    },
  },
  {
    accessor: "tst_execution",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <Col style={{ textAlign: "left" }}>
          {rowInfo.tst_execution ? FormatDateWTime(rowInfo.tst_execution) : "-"}
        </Col>
      );
    },
    Header: () => {
      return (
        <div style={{ textAlign: "center", fontWeight: "bold" }}>Ejecucion</div>
      );
    },
  },
  {
    accessor: "vc_template",
    Header: "Template",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Col style={{ textAlign: "left", fontSize: "smaller" }}>
            {rowInfo.vc_template}
          </Col>
        </>
      );
    },
  },
  {
    accessor: "i_contacts",
    Header: "Contactos",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Col style={{ textAlign: "left", fontSize: "smaller" }}>
            {rowInfo.i_contacts}
          </Col>
        </>
      );
    },
  },
  {
    accessor: "b_processed",
    Header: "Procesada",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          {rowInfo.b_processed ? (
            <Badge bg="primary">Procesada</Badge>
          ) : (
            <Badge bg="secondary">En Espera</Badge>
          )}
        </>
      );
    },
  },
];

const ExternalCampaignsList = ({ listCampaigns, periodStr }) => {
  return (
    <>
      {listCampaigns && (
        <AdvanceTableWrapper
          columns={columns}
          data={listCampaigns}
          sortable
          pagination
          perPage={10}
        >
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="DbDetails2">
                <Stack direction="horizontal" gap={2}>
                  <AiIcons.AiOutlineCalendar />
                  <div className="ms-auto">
                    <p>{periodStr}</p>
                  </div>
                </Stack>
                <div className="details">Rango de fechas</div>
              </div>
            </Col>
          </Row>
          <div>
            <div style={{ textAlign: "left" }}>
              <h4>Resumen</h4>
            </div>
            <div style={{ textAlign: "right" }}>
              <BtnExportToExcell
                dataReport={listCampaigns}
                fileName="SMS_Report"
              ></BtnExportToExcell>
            </div>
          </div>

          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: "sm",
              striped: true,
              className: "fs--1 mb-0 overflow-hidden",
            }}
          />
          <AdvanceTablePagination table />
          <AdvanceTableFooter
            rowCount={listCampaigns.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
            pageSize={10}
          />
        </AdvanceTableWrapper>
      )}
    </>
  );
};
ExternalCampaignsList.propTypes = {
  listCampaigns: PropTypes.array.isRequired,
  periodStr: PropTypes.string.isRequired,
};
export default ExternalCampaignsList;
